import Font1 from '../Images/Questionnaire/font1.png'
import Font2 from '../Images/Questionnaire/font2.png'
import Font3 from '../Images/Questionnaire/font3.png'
import Font4 from '../Images/Questionnaire/font4.png'
import Font5 from '../Images/Questionnaire/font5.png'
import Font6 from '../Images/Questionnaire/font6.png'

import Patter1 from '../Images/Questionnaire/patterns-1.png'
import Patter2 from '../Images/Questionnaire/patterns-2.png'
import Patter3 from '../Images/Questionnaire/patterns-3.png'
import Patter4 from '../Images/Questionnaire/patterns-4.png'
import Patter5 from '../Images/Questionnaire/patterns-5.png'

import Texture1 from '../Images/Questionnaire/tectures-1.png'
import Texture2 from '../Images/Questionnaire/textures-2.png'
import Texture3 from '../Images/Questionnaire/textures-3.png'
import Texture4 from '../Images/Questionnaire/textures-4.png'
import Texture5 from '../Images/Questionnaire/textures-5.png'

import Clean1 from '../Images/Questionnaire/clean-1.png'
import Clean2 from '../Images/Questionnaire/clean-2.png'
import Clean3 from '../Images/Questionnaire/clean-3.png'
import Clean4 from '../Images/Questionnaire/clean-4.png'
import Clean5 from '../Images/Questionnaire/clean-5.png'

import Collages1 from '../Images/Questionnaire/collages-1.png'
import Collages2 from '../Images/Questionnaire/collages-2.png'
import Collages3 from '../Images/Questionnaire/collages-3.png'
import Collages4 from '../Images/Questionnaire/collages-4.png'
import Collages5 from '../Images/Questionnaire/collages-5.png'

import Illustrations1 from '../Images/Questionnaire/illustrations-1.png'
import Illustrations2 from '../Images/Questionnaire/illustrations-2.png'
import Illustrations3 from '../Images/Questionnaire/illustrations-3.png'
import Illustrations4 from '../Images/Questionnaire/illustrations-4.png'
import Illustrations5 from '../Images/Questionnaire/illustrations-5.png'

import Frames1 from '../Images/Questionnaire/frames-1.png'
import Frames2 from '../Images/Questionnaire/frames-2.png'
import Frames3 from '../Images/Questionnaire/frames-3.png'
import Frames4 from '../Images/Questionnaire/frames-4.png'

import Cap1 from '../Images/Questionnaire/caps1.jpg'
import Cap2 from '../Images/Questionnaire/caps2.jpg'
import Cap3 from '../Images/Questionnaire/caps3.jpg'

import Logo1 from '../Images/Questionnaire/logo1.jpg'
import Logo2 from '../Images/Questionnaire/logo2.jpg'
import Logo3 from '../Images/Questionnaire/logo3.jpg'

import D1 from '../Images/Questionnaire/detailed/d1.jpg'
import D2 from '../Images/Questionnaire/detailed/d2.jpg'
import D3 from '../Images/Questionnaire/detailed/d3.jpg'

import MMP1 from '../Images/Questionnaire/mixed_painting/Mixed Media Painting@2x-80.jpg'
import MMP2 from '../Images/Questionnaire/mixed_painting/Mixed Media Painting_2@2x-80.jpg'
import MMP3 from '../Images/Questionnaire/mixed_painting/Mixed Media Painting_1@2x-80.jpg'

import MMO1 from '../Images/Questionnaire/mixed_outline/Mixed Media No Outline@2x-80.jpg'
import MMO2 from '../Images/Questionnaire/mixed_outline/Mixed Media No Outline_2@2x-80.jpg'
import MMO3 from '../Images/Questionnaire/mixed_outline/Mixed Media No Outline_1@2x-80.jpg'

import SM1 from '../Images/Questionnaire/smooth/Smooth Painting@2x-80.jpg'
import SM2 from '../Images/Questionnaire/smooth/Smooth Painting_1@2x-80.jpg'
import SM3 from '../Images/Questionnaire/smooth/Smooth Painting_2@2x-80.jpg'

import WATER1 from '../Images/Questionnaire/watercolor/Washy Watercolor_2@2x-80.jpg'
import WATER2 from '../Images/Questionnaire/watercolor/Washy Watercolor@2x-80.jpg'
import WATER3 from '../Images/Questionnaire/watercolor/Washy Watercolor_1@2x-80.jpg'

import RF1 from '../Images/Questionnaire/refined/Refined Hatching@2x-80.jpg'
import RF2 from '../Images/Questionnaire/refined/Refined Hatching_1@2x-80.jpg'
import RF3 from '../Images/Questionnaire/refined/Refined Hatching_2@2x-80.jpg'

import C1 from '../Images/Questionnaire/colored/Colored Outline@2x-80.jpg'
import C2 from '../Images/Questionnaire/colored/Colored Outline_1@2x-80.jpg'
import C3 from '../Images/Questionnaire/colored/Colored Outline_2@2x-80.jpg'

import F1 from '../Images/Questionnaire/fast/Fast Sketching@2x-80.jpg'
import F2 from '../Images/Questionnaire/fast/Fast Sketching_2@2x-80.jpg'
import F3 from '../Images/Questionnaire/fast/Fast Sketching_1@2x-80.jpg'

import T1 from '../Images/Questionnaire/textured/Textured Icons@2x-80.jpg'
import T2 from '../Images/Questionnaire/textured/Textured Icons_1@2x-80.jpg'
import T3 from '../Images/Questionnaire/textured/Textured Icons_2@2x-80.jpg'

import FL1 from '../Images/Questionnaire/flat/Flat Icons@2x-80.jpg'
import FL2 from '../Images/Questionnaire/flat/Flat Icons_2@2x-80.jpg'
import FL3 from '../Images/Questionnaire/flat/Flat Icons_1@2x-80.jpg'

import O1 from '../Images/Questionnaire/organic/Organic Abstract@2x-80.jpg'
import O2 from '../Images/Questionnaire/organic/Organic Abstract_2@2x-80.jpg'
import O3 from '../Images/Questionnaire/organic/Organic Abstract_1@2x-80.jpg'

import G1 from '../Images/Questionnaire/geometric/Geometric Abstract@2x-80.jpg'
import G2 from '../Images/Questionnaire/geometric/Geometric Abstract_2@2x-80.jpg'
import G3 from '../Images/Questionnaire/geometric/Geometric Abstract_1@2x-80.jpg'

import M1 from '../Images/Questionnaire/motif/Motif Pattern@1.5x-80.jpg'
import M2 from '../Images/Questionnaire/motif/Motif Pattern_2-80.jpg'
import M3 from '../Images/Questionnaire/motif/Motif Pattern_1@1.5x-80.jpg'

import P1 from '../Images/Questionnaire/png/PNG@2x-80.jpg'
import P2 from '../Images/Questionnaire/png/PNG_1@2x-80.jpg'
import P3 from '../Images/Questionnaire/png/PNG_2@2x-80.jpg'
import P4 from '../Images/Questionnaire/png/PNG_3@2x-80.jpg'
import P5 from '../Images/Questionnaire/png/PNG_4@2x-80.jpg'

import V1 from '../Images/Questionnaire/vector/Vector@2x-80.jpg'
import V2 from '../Images/Questionnaire/vector/Vector_1@2x-80.jpg'
import V3 from '../Images/Questionnaire/vector/Vector_2@2x-80.jpg'
import V4 from '../Images/Questionnaire/vector/Vector_3@2x-80.jpg'
import V5 from '../Images/Questionnaire/vector/Vector_4@2x-80.jpg'


export const colorCodes = [
        "#e8f1fe", "#e6f8fe", "#dbfef0", "#eefed5", "#fef6d5", "#fef2ea", "#feebea", "#feebf7", "#f2effe",
        "#cbdffe", "#c5ecfa", "#b9f2da", "#d2f0a6", "#f7e59f", "#fdddc7", "#fed4d1", "#fccfeb", "#f2effe",
        "#83b7fe", "#9cd8ed", "#7ee1b7", "#b2de72", "#f4cc47", "#fdc094", "#fc9790", "#f696d1", "#ded7fc", "#579cfe", "#6cc2df", "#4bcd96", "#93c648", "#e1b103", "#fda262", "#f77168", "#e674ba", "#b7abf5", "#388afe", "#42b1d6", "#2aba7f", "#81B436", "#ce9e02", "#f2893f", "#f05b50", "#d962ab", "#9e8eee", "#1d7afb", "#2897bc", "#229f6b", "#6a9923", "#b28500", "#e46910", "#e1483d", "#cb519c", "#8e7ee6", "#0c66e3", "#227d9a", "#1f835a", "#5b7f24", "#936f00", "#c15100", "#c8372c", "#ad4786", "#8170da", "#0055cb", "#206a82", "#216e4e", "#4c6b1f", "#7e5f01", "#a44800", "#ad2e24", "#933d73", "#6e5dc5", "#09326c", "#164555", "#164b35", "#37471f", "#533f04", "#702e00", "#5d1f1a", "#50253f", "#5e4db1", "#1c2b41", "#1e3137", "#1c3329", "#28311b", "#332e1b", "#38291e", "#42221f", "#3d2232", "#352c63"
]

export const textStyle = [
        {
                fontStyle: 'Clean',
                fontStyle_arabic:'نظيف وبسيط',
                img:Font1
        },
        {
                fontStyle: 'Elegant Serif',
                fontStyle_arabic:'كلاسيكي أنيق',
                img:Font2

        },
        {
                fontStyle: 'Script',
                fontStyle_arabic:'خط يدوي',
                img:Font3

        },
        {
                fontStyle: 'Typewriter',
                fontStyle_arabic:'خط آلة كاتبة',
                img:Font4

        },
        {
                fontStyle: 'Fun & Unique',
                fontStyle_arabic:'ممتع ومميز',
                img:Font5

        },
        {
                fontStyle: 'Modern',
                fontStyle_arabic:'خط عصري',
                img:Font6

        },
]

export const capitalStyles = [
    {
        value: 'all caps',
        fontStyle: 'ALL CAPS',
        fontStyle_arabic:'جميع الحروف كبيرة',
        img:Cap1
    },
    {
        value: 'all lowercase',
        fontStyle: 'all lowercase',
        fontStyle_arabic:'جميع الحروف صغيرة',
        img:Cap3
    },
    {
        value: 'first letter only capitalized',
        fontStyle: 'First letter only capitalized',
        fontStyle_arabic:'أول حرف فقط كبير',
        img:Cap2
    }
]

export const logoStyles = [
    {
        value: 'monogram',
        fontStyle: 'Monogram',
        fontStyle_arabic:'مونوغرام (حروف)',
        img:Logo2
    },
    {
        value: 'pictorial',
        fontStyle: 'Pictorial',
        fontStyle_arabic:'رمز تصويري',
        img:Logo3
    },
    {
        value: 'abstract',
        fontStyle: 'Abstract',
        fontStyle_arabic:'رمز تجريدي',
        img:Logo1
    }
]

export const illustrationStyles = [
    {
        value: 'detailed rendering',
        fontStyle: 'Detailed Rendering',
        fontStyle_arabic:'رسم تفصيلي دقيق',
        img:[D2, D1, D3, D1, D2]
    },
    {
        value: 'painting with outline',
        fontStyle: 'Painting with outline',
        fontStyle_arabic:'تظليل مع تحديد',
        img:[MMP1, MMP2, MMP3, MMP1, MMP2]
    },
    // {
    //     value: 'mixed media no outline',
    //     fontStyle: 'Mixed Media No Outline',
    //     fontStyle_arabic:'وسائط مختلطة بدون مخطط تفصيلي',
    //     img:[MMO1, MMO2, MMO3, MMO1, MMO2]
    // },
    {
        value: 'smooth painting',
        fontStyle: 'Smooth Painting',
        fontStyle_arabic:'تظليل ناعم',
        img:[SM1, SM2, SM3, SM1, SM2]
    },
    {
        value: 'washy watercolor',
        fontStyle: 'Wash watercolor',
        fontStyle_arabic:'ألوان مائية',
        img:[WATER1, WATER2, WATER3, WATER1, WATER2]
    },
    {
        value: 'refined hatching',
        fontStyle: 'Refined Hatching',
        fontStyle_arabic:'تهشير متقن',
        img:[RF1, RF2, RF3, RF1, RF2]
    },
    {
        value: 'colored outline',
        fontStyle: 'Colored Outline',
        fontStyle_arabic:'تلوين مسطح مع تحديد',
        img:[C1, C2, C3, C1, C2]
    },
    {
        value: 'fast sketching',
        fontStyle: 'Fast Sketching',
        fontStyle_arabic:'سكتش سريع',
        img:[F1, F2, F3, F1, F2]
    },
    {
        value: 'textured icons',
        fontStyle: 'Textured Icons',
        fontStyle_arabic:'أيقونات بخامات',
        img:[T1, T2, T3, T1, T2]
    },
    {
        value: 'flat icons',
        fontStyle: 'Flat Icons',
        fontStyle_arabic:'أيقونات مسطحة',
        img:[FL1, FL2, FL3, FL1, FL2]
    },
    {
        value: 'organic abstract',
        fontStyle: 'Organic abstract',
        fontStyle_arabic:'عضوي تجريدي',
        img:[O1, O2, O3, O1, O2]
    },
    {
        value: 'geometric abstract',
        fontStyle: 'Geometric abstract',
        fontStyle_arabic:'هندسي تجريدي',
        img:[G1, G2, G3, G1, G2]
    },
    {
        value: 'motif pattern',
        fontStyle: 'Motif Pattern',
        fontStyle_arabic:'نمط بنقوش',
        img:[M1, M2, M3, M1, M2]
    },
]

export const illustrationFormat = [
    {
        value: 'png',
        info: 'Ready to use detailed image (shading, watercolor). Hard to edit colors or scale up.',
        fontStyle: 'PNG',
        fontStyle_arabic:'PNG',
        img:[P1, P2, P3, P4, P5]
    },
    {
        value: 'vector',
        info: 'Editable illustration (simpler, solid colors). Easy to change colors and scale to any size.',
        fontStyle: 'Vector',
        fontStyle_arabic:'فكتر',
        img:[V1, V2, V3, V4, V5]
    }
]

export const textureImages1 =[Patter1,Patter2,Patter3,Patter4,Patter5];
export const textureImages2 =[Texture1,Texture2,Texture3,Texture4,Texture5];
export const textureImages4 =[Clean1,Clean2,Clean3,Clean4,Clean5];
export const textureImages3 =[Collages1,Collages2,Collages3,Collages4,Collages5];
export const textureImages5 =[Illustrations1,Illustrations2,Illustrations3,Illustrations4,Illustrations5];
export const textureImages6 =[Frames1,Frames2,Frames3,Frames1,Frames3];
